
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField, Switchbox } from '@samc/centricity-core';
  import { TradingAccountSource } from '@/Sources';
  import { ITradingAccount } from '@/Interfaces';

  @Component({
    name: 'trading-account-dropdown-field',
    components: { Field, DropdownField, Switchbox }
  })
  export default class TradingAccountDropdownField extends Vue {
    @Prop({ default: 'Trading Account' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ type: Number, default: undefined }) public entityId!: number;

    public source: TradingAccountSource | null = null;
    public showAllTrdAccounts: boolean = false;

    public get computedShowAllTrdAccounts(): boolean {
      return this.showAllTrdAccounts || this.entityId === null || this.entityId === undefined;
    }

    mounted() {
      this.source = new TradingAccountSource(this.computedShowAllTrdAccounts ? null : this.entityId);
    }

    public innerValue: ITradingAccount | null = null;

    public get val(): ITradingAccount | null { return this.innerValue; }
    public set val(value: ITradingAccount | null) {
      this.$emit('trading-account', value);
      this.innerValue = value;
    }

    @Watch('value')
    public onValueChange(newValue: string) {
      this.val = this.source?.items.find(x => x.account === newValue) ?? null;
    }

    @Watch('showAllTrdAccounts')
    public onShowAllTrdAccountsChange(newValue: boolean) {
      this.showAllTrdAccounts = newValue;
      this.source = new TradingAccountSource(newValue || this.entityId === null || this.entityId === undefined ? null : this.entityId);
    }
}
